var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import TargettedSystemContext from '../../context/targetted-system-context';
import { TargettedSystems } from '../../helpers/constants';
import { getGeometryStyle, getMinimumHeight, getMinimumWidth } from '../../helpers/styles';
import useRadioFormItem from '../../hooks/useRadioFormItem';
import Label from '../Label';
var getMinHeightWidth = function (minimumSize) {
    return "\n  min-height: " + getMinimumHeight(minimumSize) + ";\n  min-width: " + getMinimumWidth(minimumSize) + ";";
};
var StyledRadioButtonContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  text-align: ", ";\n  display: ", ";\n  align-items: ", ";\n"], ["\n  ", "\n  ", "\n  text-align: ", ";\n  display: ", ";\n  align-items: ", ";\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return minimumSize && getMinHeightWidth(minimumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.textAlign;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.display;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.alignItems;
});
var StyledRadioButton = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  margin-right: ", ";\n  transform: ", ";\n  border: ", ";\n  ", "\n"], ["\n  height: ", ";\n  width: ", ";\n  margin-right: ", ";\n  transform: ", ";\n  border: ", ";\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.button.height;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.button.width;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.button.marginRight;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.button.transform;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.button.border;
}, function (_a) {
    var checked = _a.checked, windowTheme = _a.windowTheme;
    return "\n        \n        background: " + (checked
        ? windowTheme.radio.button.checked.background
        : windowTheme.radio.button.background) + ";\n        border-left-color: " + (checked
        ? windowTheme.radio.button.checked.borderColor.left
        : windowTheme.radio.button.borderColor.left) + ";\n        border-top-color: " + (checked
        ? windowTheme.radio.button.checked.borderColor.top
        : windowTheme.radio.button.borderColor.top) + ";\n        border-right-color: " + (checked
        ? windowTheme.radio.button.checked.borderColor.right
        : windowTheme.radio.button.borderColor.right) + ";\n        border-bottom-color: " + (checked
        ? windowTheme.radio.button.checked.borderColor.bottom
        : windowTheme.radio.button.borderColor.bottom) + ";\n    ";
});
var StyledLabel = styled(Label).attrs(function (props) { })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-left: ", ";\n  border: ", ";\n  color: ", ";\n"], ["\n  margin-left: ", ";\n  border: ", ";\n  color: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.label.marginLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.label.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.label.color;
});
var StyledInput = styled.input.attrs(function (props) { })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  min-width: ", ";\n  accent-color: ", ";\n"], ["\n  min-width: ", ";\n  accent-color: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.input.minWidth;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.radio.input.accentColor;
});
var RadioButton = function (props) {
    var attributes = props.attributes, identifier = props.identifier, parentWidget = props.parentWidget, type = props.type, children = props.children, parentIdentifier = props.parentIdentifier, className = props.className, restProps = __rest(props, ["attributes", "identifier", "parentWidget", "type", "children", "parentIdentifier", "className"]), text = attributes.text, geometry = attributes.geometry, checked = attributes.checked, minimumSize = attributes.minimumSize, restAttributes = __rest(attributes, ["text", "geometry", "checked", "minimumSize"]);
    var handleClick = function (evt) {
        var inputElement = evt.target.previousSibling;
        inputElement.click();
    };
    var formItemProps = useRadioFormItem(identifier, parentWidget, function (evt) { return evt.target.checked; });
    var selected = formItemProps.value[identifier] || false;
    var targetSystem = useContext(TargettedSystemContext);
    return (React.createElement(StyledRadioButtonContainer, __assign({ geometry: geometry, minimumSize: minimumSize }, restAttributes, restProps),
        React.createElement(StyledInput, __assign({}, restProps, restAttributes, { type: "radio", id: identifier, style: targetSystem === TargettedSystems.S80 ? { display: 'none' } : {}, name: parentIdentifier }, formItemProps, { checked: selected })),
        React.createElement(StyledRadioButton, __assign({ id: identifier, style: targetSystem === TargettedSystems.CATIZ ||
                targetSystem === TargettedSystems.HERMESYS
                ? { display: 'none' }
                : {}, checked: selected, onClick: handleClick }, restProps)),
        React.createElement(StyledLabel, { attributes: { text: text }, windowTheme: restProps.windowTheme })));
};
export default RadioButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map